export default crm => {
  const companyName = crm?.client?.person?.company?.name;
  const person = crm?.client?.person || {};
  return companyName || `${ person.name } ${ person.surname }`.trim();
}
